import { isSameDay, isToday } from "date-fns";
import { Flag } from "lucide-react";
import Button from "../../../components/Button/Button";
import { LESSON_STATUS } from "../LessonPlannerConstant";
import { formatDate, formatTimeRange, getSubjectTone, getWeekDays, parseDate } from "../utils/lessonPlanUtils";

const LessonCalendarView = ({ weekStart, lessons, onView, onCreate }) => (
  <div className="lp-calendar-scroll">
    <div className="lp-calendar">
      {getWeekDays(weekStart).map((date) => {
        const dayLessons = lessons
          .filter((lesson) => isSameDay(parseDate(lesson.lessonDate), date))
          .sort((a, b) => (a.startTime || "").localeCompare(b.startTime || ""));

        return (
          <section key={date.toISOString()} className={`lp-calendar__day ${isToday(date) ? "is-today" : ""}`}>
            <header>
              <span>{formatDate(date, "EEE")}</span>
              <strong>{formatDate(date, "d")}</strong>
            </header>
            <div className="lp-calendar__items">
              {dayLessons.length === 0 && <p className="lp-calendar__empty">No lessons</p>}
              {dayLessons.map((lesson, index) => {
                const tone = getSubjectTone(lesson.subjectName);
                const isCompleted = lesson.status === LESSON_STATUS.COMPLETED;
                return (
                  <Button
                    key={lesson.id ?? `slot-${index}`}
                    variant="plain"
                    className={`lp-btn-plain lp-calendar__item lp-accent-${tone} ${lesson.hasPlan ? "" : "is-empty"} ${
                      isCompleted ? "is-completed" : ""
                    }`}
                    onClick={() => (lesson.hasPlan ? onView(lesson) : onCreate(lesson))}
                  >
                    <span className="lp-calendar__subject">
                      {lesson.subjectName}
                      {lesson.isFlagged && <Flag size={10} className="lp-text-danger" />}
                    </span>
                    <span className="lp-calendar__title">{lesson.hasPlan ? lesson.title : "+ Create lesson plan"}</span>
                    <span className="lp-calendar__time">
                      {lesson.programName} · {formatTimeRange(lesson.startTime, lesson.endTime)}
                    </span>
                  </Button>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  </div>
);

export default LessonCalendarView;
